export default "__VITE_ASSET__Cgw1ankl__"